import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import { getURLbyEndPointV2 } from "../../store/api";

const SpeakerMeetingRoom = () => {
  const { meetingRoomId } = useParams();
  const [loading, setLoading] = useState(true);
  const [meetingValid, setMeetingValid] = useState(false);
  const [meetingData, setMeetingData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [joinStatus, setJoinStatus] = useState("INIT"); // INIT, REQUESTED, WAIT, ALLOWED
  const [pollingInfo, setPollingInfo] = useState(null); // intervalId
  const [participantId, setParticipantId] = useState("");
  const [participantName, setParticipantName] = useState("");

  // Hardcoded credentials
  const appID = 1871154113;
  const serverSecret = "7625a483cfcaa01920c9f3ceeaab8ff2";

  const checkMeeting = React.useCallback(async () => {
    try {
      const url = getURLbyEndPointV2("getCloudMeeting", meetingRoomId);
      const finalUrl = url.replace(":id", meetingRoomId) + "?role=speaker";
      const res = await axios.get(finalUrl);
      if (res.data.status) {
        setMeetingValid(true);
        setMeetingData(res.data.data);

        let userId = sessionStorage.getItem("guestUserId");
        if (!userId) {
          userId = "speaker_" + Math.floor(Math.random() * 10000000);
          sessionStorage.setItem("guestUserId", userId);
        }
        setParticipantId(userId);

        const speakerName = res.data.data?.userName || "AECCI SPEAKER";
        setParticipantName(speakerName);

        checkInitialStatus(userId, speakerName, res.data.data?.email || "");
      } else {
        setMeetingValid(false);
        setErrorMessage("Meeting not found or invalid.");
      }
    } catch (error) {
      console.error("Meeting check failed", error);
      setMeetingValid(false);
      setErrorMessage(
        error.response?.data?.message ||
          "An error occurred while validating the meeting.",
      );
      setLoading(false);
    }
  }, [meetingRoomId]);

  const checkInitialStatus = async (userId, userName, email) => {
    try {
      const res = await axios.post(getURLbyEndPointV2("checkJoinStatus"), {
        meetingRoomId,
        userId: userId,
      });
      if (res.data.status && res.data.allowed) {
        setJoinStatus("ALLOWED");
        setLoading(false);
      } else {
        requestToJoin(userId, userName, email);
      }
    } catch (error) {
      console.error("Check status failed:", error);
      setLoading(false);
    }
  };

  const requestToJoin = async (userId, userName, email) => {
    try {
      setJoinStatus("REQUESTED");
      const res = await axios.post(getURLbyEndPointV2("requestJoin"), {
        meetingRoomId,
        userId: userId,
        name: userName,
        email: email,
        role: "Speaker",
      });

      if (res.data.status) {
        if (res.data.allowed) {
          setJoinStatus("ALLOWED");
          setLoading(false);
        } else {
          setJoinStatus("WAITING");
          setLoading(false);
          startPolling(userId);
        }
      }
    } catch (error) {
      console.error("Request join failed:", error);
      setLoading(false);
    }
  };

  const startPolling = (userId) => {
    const interval = setInterval(async () => {
      try {
        const res = await axios.post(getURLbyEndPointV2("checkJoinStatus"), {
          meetingRoomId,
          userId: userId,
        });
        if (res.data.status && res.data.allowed) {
          setJoinStatus("ALLOWED");
          clearInterval(interval);
        }
      } catch (e) {
        console.error(e);
      }
    }, 3000); // Check every 3 seconds
    setPollingInfo(interval);
  };

  useEffect(() => {
    checkMeeting();
  }, [checkMeeting]);

  useEffect(() => {
    return () => {
      if (pollingInfo) clearInterval(pollingInfo);
    };
  }, [pollingInfo]);

  const zpRef = React.useRef(false);

  const myMeeting = async (element) => {
    if (!element || zpRef.current) return;
    zpRef.current = true;

    const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
      appID,
      serverSecret,
      meetingRoomId,
      participantId,
      participantName,
    );

    // const getDynamicHeader = () => {
    //   if (!meetingData) return "AECCI-IAC";
    //   let formattedDate = "";
    //   if (meetingData.meetingDate) {
    //     const d = new Date(meetingData.meetingDate);
    //     const DD = String(d.getDate()).padStart(2, "0");
    //     const MM = String(d.getMonth() + 1).padStart(2, "0");
    //     const YYYY = d.getFullYear();
    //     formattedDate = `${DD}/${MM}/${YYYY}`;
    //   }
    //   let formattedTime = meetingData.meetingTime || "";
    //   if (formattedTime) {
    //     const [hours, minutes] = formattedTime.split(":");
    //     const hoursInt = parseInt(hours, 10);
    //     const ampm = hoursInt >= 12 ? "PM" : "AM";
    //     const displayHours = hoursInt % 12 || 12;
    //     formattedTime = `${String(displayHours).padStart(2, "0")}:${minutes}${ampm}`;
    //   }
    //   return `AECCI-IAC, ${meetingData.meetingTitle || "Meeting"}, ${formattedDate} ${formattedTime}`.trim();
    // };

    const zp = ZegoUIKitPrebuilt.create(kitToken);
    zp.joinRoom({
      container: element,
      scenario: {
        mode: ZegoUIKitPrebuilt.VideoConference,
      },
      showPreJoinView: true,
      branding: {
        logoURL:
          "https://www.aecci.org.in/wp-content/uploads/2020/10/AECCI-24.png",
        // headerTitle: getDynamicHeader(),
      },
      layout: "Grid",
      showScreenSharingButton: true,
      showMyCameraToggleButton: true,
      showMyMicrophoneToggleButton: true,
      showAudioVideoSettingsButton: true,
      showLeavingView: true,
      showLeaveRoomConfirmDialog: true,
      showUserList: true,
      showTextChat: true,
      turnOnCameraWhenJoining: true,
      turnOnMicrophoneWhenJoining: true,
      sharedLinks: [
        {
          name: "Join link",
          url: window.location.href,
        },
      ],
      onLeaveRoom: () => {
        window.location.href = "/";
      },
    });
  };

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        backgroundColor: "#0B1A33",
        position: "relative",
      }}
    >
      {loading ? (
        <div className="d-flex justify-content-center align-items-center h-100 text-white">
          <Spinner animation="border" />{" "}
          <span className="ms-2">Validating Meeting...</span>
        </div>
      ) : joinStatus === "WAITING" || joinStatus === "REQUESTED" ? (
        <div className="d-flex flex-column justify-content-center align-items-center h-100 text-white p-4">
          <Spinner animation="grow" variant="light" />
          <h3 className="mt-3">Waiting for Host Approval...</h3>
          <p>Please stay on this screen until the Host lets you in.</p>
        </div>
      ) : meetingValid && joinStatus === "ALLOWED" ? (
        <>
          <style>{`
            .custom-meeting-banner {
              position: absolute;
              top: 10px;
              left: 50%;
              transform: translateX(-50%);
              padding: 10px 20px;
              background: #19649D;
              color: white;
              font-size: 18px;
              font-weight: 600;
              border-radius: 8px;
              z-index: 9999;
              text-align: center;
              white-space: nowrap;
            }
            @media (max-width: 768px) {
              .custom-meeting-banner {
                width: 100vw;
                max-width: 100vw;
                top: 0;
                border-radius: 0;
                font-size: 13px;
                padding: 8px 10px;
                white-space: normal;
              }
            }
          `}</style>
          <div className="custom-meeting-banner">
            {meetingData
              ? (() => {
                  let formattedDate = "";
                  if (meetingData.meetingDate) {
                    const d = new Date(meetingData.meetingDate);
                    const DD = String(d.getDate()).padStart(2, "0");
                    const MM = String(d.getMonth() + 1).padStart(2, "0");
                    const YYYY = d.getFullYear();
                    formattedDate = `${DD}/${MM}/${YYYY}`;
                  }
                  let formattedTime = meetingData.meetingTime || "";
                  if (formattedTime) {
                    const [hours, minutes] = formattedTime.split(":");
                    const hoursInt = parseInt(hours, 10);
                    const ampm = hoursInt >= 12 ? "PM" : "AM";
                    const displayHours = hoursInt % 12 || 12;
                    formattedTime = `${String(displayHours).padStart(2, "0")}:${minutes}${ampm}`;
                  }
                  return `AECCI-IAC, ${meetingData.meetingTitle || "Meeting"}`.trim();
                })()
              : "AECCI-IAC"}
          </div>
          <div
            ref={myMeeting}
            style={{ width: "100vw", height: "100vh" }}
          ></div>
        </>
      ) : (
        <div
          className="text-white text-center p-4 mt-5 mx-auto"
          style={{
            backgroundColor: "rgba(0,0,0,0.6)",
            borderRadius: "10px",
            maxWidth: "400px",
          }}
        >
          <h3>Access Denied / Invalid Meeting</h3>
          <p>{errorMessage || "You must be approved by the admin to join."}</p>
        </div>
      )}
    </div>
  );
};

export default SpeakerMeetingRoom;
